export const Countries = [
  {
    CountryName: "Andorra",
    CountryCode: "AD",
  },
  {
    CountryName: "United Arab Emirates",
    CountryCode: "AE",
  },
  {
    CountryName: "Afghanistan",
    CountryCode: "AF",
  },
  {
    CountryName: "Antigua and Barbuda",
    CountryCode: "AG",
  },
  {
    CountryName: "Anguilla",
    CountryCode: "AI",
  },
  {
    CountryName: "Albania",
    CountryCode: "AL",
  },
  {
    CountryName: "Armenia",
    CountryCode: "AM",
  },
  {
    CountryName: "Netherlands Antilles",
    CountryCode: "AN",
  },
  {
    CountryName: "Angola",
    CountryCode: "AO",
  },
  {
    CountryName: "Antarctica",
    CountryCode: "AQ",
  },
  {
    CountryName: "Argentina",
    CountryCode: "AR",
  },
  {
    CountryName: "American Samoa",
    CountryCode: "AS",
  },
  {
    CountryName: "Austria",
    CountryCode: "AT",
  },
  {
    CountryName: "Australia",
    CountryCode: "AU",
  },
  {
    CountryName: "Aruba",
    CountryCode: "AW",
  },
  {
    CountryName: "Aland Islands",
    CountryCode: "AX",
  },
  {
    CountryName: "Azerbaijan",
    CountryCode: "AZ",
  },
  {
    CountryName: "Bosnia and Herzegovina",
    CountryCode: "BA",
  },
  {
    CountryName: "Barbados",
    CountryCode: "BB",
  },
  {
    CountryName: "Bangladesh",
    CountryCode: "BD",
  },
  {
    CountryName: "Belgium",
    CountryCode: "BE",
  },
  {
    CountryName: "Burkina Faso",
    CountryCode: "BF",
  },
  {
    CountryName: "Bulgaria",
    CountryCode: "BG",
  },
  {
    CountryName: "Bahrain",
    CountryCode: "BH",
  },
  {
    CountryName: "Burundi",
    CountryCode: "BI",
  },
  {
    CountryName: "Benin",
    CountryCode: "BJ",
  },
  {
    CountryName: "Saint Barthelemy",
    CountryCode: "BL",
  },
  {
    CountryName: "Bermuda",
    CountryCode: "BM",
  },
  {
    CountryName: "Brunei Darussalam",
    CountryCode: "BN",
  },
  {
    CountryName: "Bolivia",
    CountryCode: "BO",
  },
  {
    CountryName: "Bonaire, Sint Eustatius and Saba",
    CountryCode: "BQ",
  },
  {
    CountryName: "Brazil",
    CountryCode: "BR",
  },
  {
    CountryName: "Bahamas",
    CountryCode: "BS",
  },
  {
    CountryName: "Bhutan",
    CountryCode: "BT",
  },
  {
    CountryName: "Bouvet Island",
    CountryCode: "BV",
  },
  {
    CountryName: "Botswana",
    CountryCode: "BW",
  },
  {
    CountryName: "Belarus",
    CountryCode: "BY",
  },
  {
    CountryName: "Belize",
    CountryCode: "BZ",
  },
  {
    CountryName: "Canada",
    CountryCode: "CA",
  },
  {
    CountryName: "Cocos (Keeling) Islands",
    CountryCode: "CC",
  },
  {
    CountryName: "Congo, Democratic Rep of",
    CountryCode: "CD",
  },
  {
    CountryName: "Central African Rep",
    CountryCode: "CF",
  },
  {
    CountryName: "Congo, Republic of",
    CountryCode: "CG",
  },
  {
    CountryName: "Switzerland",
    CountryCode: "CH",
  },
  {
    CountryName: "Cote d'Ivoire",
    CountryCode: "CI",
  },
  {
    CountryName: "Cook Islands",
    CountryCode: "CK",
  },
  {
    CountryName: "Chile",
    CountryCode: "CL",
  },
  {
    CountryName: "Cameroon",
    CountryCode: "CM",
  },
  {
    CountryName: "China",
    CountryCode: "CN",
  },
  {
    CountryName: "Colombia",
    CountryCode: "CO",
  },
  {
    CountryName: "Costa Rica",
    CountryCode: "CR",
  },
  {
    CountryName: "Cuba",
    CountryCode: "CU",
  },
  {
    CountryName: "Cape Verde",
    CountryCode: "CV",
  },
  {
    CountryName: "Curacao",
    CountryCode: "CW",
  },
  {
    CountryName: "Christmas Island",
    CountryCode: "CX",
  },
  {
    CountryName: "Cyprus",
    CountryCode: "CY",
  },
  {
    CountryName: "Czech Rep",
    CountryCode: "CZ",
  },
  {
    CountryName: "Germany",
    CountryCode: "DE",
  },
  {
    CountryName: "Djibouti",
    CountryCode: "DJ",
  },
  {
    CountryName: "Denmark",
    CountryCode: "DK",
  },
  {
    CountryName: "Dominica",
    CountryCode: "DM",
  },
  {
    CountryName: "Dominican Rep",
    CountryCode: "DO",
  },
  {
    CountryName: "Algeria",
    CountryCode: "DZ",
  },
  {
    CountryName: "Ecuador",
    CountryCode: "EC",
  },
  {
    CountryName: "Estonia",
    CountryCode: "EE",
  },
  {
    CountryName: "Egypt",
    CountryCode: "EG",
  },
  {
    CountryName: "Western Sahara",
    CountryCode: "EH",
  },
  {
    CountryName: "Eritrea",
    CountryCode: "ER",
  },
  {
    CountryName: "Spain",
    CountryCode: "ES",
  },
  {
    CountryName: "Ethiopia",
    CountryCode: "ET",
  },
  {
    CountryName: "Finland",
    CountryCode: "FI",
  },
  {
    CountryName: "Fiji",
    CountryCode: "FJ",
  },
  {
    CountryName: "Falkland Islands",
    CountryCode: "FK",
  },
  {
    CountryName: "Micronesia",
    CountryCode: "FM",
  },
  {
    CountryName: "Faroe Islands",
    CountryCode: "FO",
  },
  {
    CountryName: "France",
    CountryCode: "FR",
  },
  {
    CountryName: "Gabon",
    CountryCode: "GA",
  },
  {
    CountryName: "United Kingdom",
    CountryCode: "GB",
  },
  {
    CountryName: "Grenada",
    CountryCode: "GD",
  },
  {
    CountryName: "Georgia",
    CountryCode: "GE",
  },
  {
    CountryName: "French Guyana",
    CountryCode: "GF",
  },
  {
    CountryName: "Guernsey",
    CountryCode: "GG",
  },
  {
    CountryName: "Ghana",
    CountryCode: "GH",
  },
  {
    CountryName: "Gibraltar",
    CountryCode: "GI",
  },
  {
    CountryName: "Greenland",
    CountryCode: "GL",
  },
  {
    CountryName: "Gambia",
    CountryCode: "GM",
  },
  {
    CountryName: "Guinea",
    CountryCode: "GN",
  },
  {
    CountryName: "Guadeloupe",
    CountryCode: "GP",
  },
  {
    CountryName: "Equatorial Guinea",
    CountryCode: "GQ",
  },
  {
    CountryName: "Greece",
    CountryCode: "GR",
  },
  {
    CountryName: "South Georgia and the South Sandwich Islands",
    CountryCode: "GS",
  },
  {
    CountryName: "Guatemala",
    CountryCode: "GT",
  },
  {
    CountryName: "Guam",
    CountryCode: "GU",
  },
  {
    CountryName: "Guinea-Bissau",
    CountryCode: "GW",
  },
  {
    CountryName: "Guyana",
    CountryCode: "GY",
  },
  {
    CountryName: "Hong Kong",
    CountryCode: "HK",
  },
  {
    CountryName: "Heard Island and McDonald Islands",
    CountryCode: "HM",
  },
  {
    CountryName: "Honduras",
    CountryCode: "HN",
  },
  {
    CountryName: "Croatia",
    CountryCode: "HR",
  },
  {
    CountryName: "Haiti",
    CountryCode: "HT",
  },
  {
    CountryName: "Hungary",
    CountryCode: "HU",
  },
  {
    CountryName: "Indonesia",
    CountryCode: "ID",
  },
  {
    CountryName: "Ireland",
    CountryCode: "IE",
  },
  {
    CountryName: "Israel",
    CountryCode: "IL",
  },
  {
    CountryName: "Isle of Man",
    CountryCode: "IM",
  },
  {
    CountryName: "India",
    CountryCode: "IN",
  },
  {
    CountryName: "British Indian Ocean Territory",
    CountryCode: "IO",
  },
  {
    CountryName: "Iraq",
    CountryCode: "IQ",
  },
  {
    CountryName: "Iran",
    CountryCode: "IR",
  },
  {
    CountryName: "Iceland",
    CountryCode: "IS",
  },
  {
    CountryName: "Italy",
    CountryCode: "IT",
  },
  {
    CountryName: "Jersey",
    CountryCode: "JE",
  },
  {
    CountryName: "Jamaica",
    CountryCode: "JM",
  },
  {
    CountryName: "Jordan",
    CountryCode: "JO",
  },
  {
    CountryName: "Japan",
    CountryCode: "JP",
  },
  {
    CountryName: "Kenya",
    CountryCode: "KE",
  },
  {
    CountryName: "Kyrgyzstan",
    CountryCode: "KG",
  },
  {
    CountryName: "Cambodia",
    CountryCode: "KH",
  },
  {
    CountryName: "Kiribati",
    CountryCode: "KI",
  },
  {
    CountryName: "Comoros",
    CountryCode: "KM",
  },
  {
    CountryName: "St Kitts and Nevis",
    CountryCode: "KN",
  },
  {
    CountryName: "Korea, North",
    CountryCode: "KP",
  },
  {
    CountryName: "Korea, South",
    CountryCode: "KR",
  },
  {
    CountryName: "Kuwait",
    CountryCode: "KW",
  },
  {
    CountryName: "Cayman Islands",
    CountryCode: "KY",
  },
  {
    CountryName: "Kazakhstan",
    CountryCode: "KZ",
  },
  {
    CountryName: "Laos",
    CountryCode: "LA",
  },
  {
    CountryName: "Lebanon",
    CountryCode: "LB",
  },
  {
    CountryName: "St Lucia",
    CountryCode: "LC",
  },
  {
    CountryName: "Liechtenstein",
    CountryCode: "LI",
  },
  {
    CountryName: "Sri Lanka",
    CountryCode: "LK",
  },
  {
    CountryName: "Liberia",
    CountryCode: "LR",
  },
  {
    CountryName: "Lesotho",
    CountryCode: "LS",
  },
  {
    CountryName: "Lithuania",
    CountryCode: "LT",
  },
  {
    CountryName: "Luxembourg",
    CountryCode: "LU",
  },
  {
    CountryName: "Latvia",
    CountryCode: "LV",
  },
  {
    CountryName: "Libya",
    CountryCode: "LY",
  },
  {
    CountryName: "Morocco",
    CountryCode: "MA",
  },
  {
    CountryName: "Monaco",
    CountryCode: "MC",
  },
  {
    CountryName: "Moldova, Rep of",
    CountryCode: "MD",
  },
  {
    CountryName: "Montenegro",
    CountryCode: "ME",
  },
  {
    CountryName: "Saint Martin",
    CountryCode: "MF",
  },
  {
    CountryName: "Madagascar",
    CountryCode: "MG",
  },
  {
    CountryName: "Marshall Islands",
    CountryCode: "MH",
  },
  {
    CountryName: "Macedonia",
    CountryCode: "MK",
  },
  {
    CountryName: "Mali",
    CountryCode: "ML",
  },
  {
    CountryName: "Myanmar",
    CountryCode: "MM",
  },
  {
    CountryName: "Mongolia",
    CountryCode: "MN",
  },
  {
    CountryName: "Macau",
    CountryCode: "MO",
  },
  {
    CountryName: "Northern Mariana Islands",
    CountryCode: "MP",
  },
  {
    CountryName: "Martinique",
    CountryCode: "MQ",
  },
  {
    CountryName: "Mauritania",
    CountryCode: "MR",
  },
  {
    CountryName: "Montserrat",
    CountryCode: "MS",
  },
  {
    CountryName: "Malta",
    CountryCode: "MT",
  },
  {
    CountryName: "Mauritius",
    CountryCode: "MU",
  },
  {
    CountryName: "Maldives",
    CountryCode: "MV",
  },
  {
    CountryName: "Malawi",
    CountryCode: "MW",
  },
  {
    CountryName: "Mexico",
    CountryCode: "MX",
  },
  {
    CountryName: "Malaysia",
    CountryCode: "MY",
  },
  {
    CountryName: "Mozambique",
    CountryCode: "MZ",
  },
  {
    CountryName: "Namibia",
    CountryCode: "NA",
  },
  {
    CountryName: "New Caledonia",
    CountryCode: "NC",
  },
  {
    CountryName: "Niger",
    CountryCode: "NE",
  },
  {
    CountryName: "Norfolk Island",
    CountryCode: "NF",
  },
  {
    CountryName: "Nigeria",
    CountryCode: "NG",
  },
  {
    CountryName: "Nicaragua",
    CountryCode: "NI",
  },
  {
    CountryName: "Netherlands",
    CountryCode: "NL",
  },
  {
    CountryName: "Norway",
    CountryCode: "NO",
  },
  {
    CountryName: "Nepal",
    CountryCode: "NP",
  },
  {
    CountryName: "Nauru",
    CountryCode: "NR",
  },
  {
    CountryName: "Niue",
    CountryCode: "NU",
  },
  {
    CountryName: "New Zealand",
    CountryCode: "NZ",
  },
  {
    CountryName: "Oman",
    CountryCode: "OM",
  },
  {
    CountryName: "Panama",
    CountryCode: "PA",
  },
  {
    CountryName: "Peru",
    CountryCode: "PE",
  },
  {
    CountryName: "French Polynesia",
    CountryCode: "PF",
  },
  {
    CountryName: "Papua New Guinea",
    CountryCode: "PG",
  },
  {
    CountryName: "Philippines",
    CountryCode: "PH",
  },
  {
    CountryName: "Pakistan",
    CountryCode: "PK",
  },
  {
    CountryName: "Poland",
    CountryCode: "PL",
  },
  {
    CountryName: "St Pierre and Miquelon",
    CountryCode: "PM",
  },
  {
    CountryName: "Pitcairn Islands",
    CountryCode: "PN",
  },
  {
    CountryName: "Puerto Rico",
    CountryCode: "PR",
  },
  {
    CountryName: "Palestinian Territory, Occupied",
    CountryCode: "PS",
  },
  {
    CountryName: "Portugal",
    CountryCode: "PT",
  },
  {
    CountryName: "Palau",
    CountryCode: "PW",
  },
  {
    CountryName: "Paraguay",
    CountryCode: "PY",
  },
  {
    CountryName: "Qatar",
    CountryCode: "QA",
  },
  {
    CountryName: "Reunion",
    CountryCode: "RE",
  },
  {
    CountryName: "Romania",
    CountryCode: "RO",
  },
  {
    CountryName: "Serbia",
    CountryCode: "RS",
  },
  {
    CountryName: "Russian Federation",
    CountryCode: "RU",
  },
  {
    CountryName: "Rwanda",
    CountryCode: "RW",
  },
  {
    CountryName: "Saudi Arabia",
    CountryCode: "SA",
  },
  {
    CountryName: "Solomon Islands",
    CountryCode: "SB",
  },
  {
    CountryName: "Seychelles",
    CountryCode: "SC",
  },
  {
    CountryName: "Sudan",
    CountryCode: "SD",
  },
  {
    CountryName: "Sweden",
    CountryCode: "SE",
  },
  {
    CountryName: "Singapore",
    CountryCode: "SG",
  },
  {
    CountryName: "St Helena",
    CountryCode: "SH",
  },
  {
    CountryName: "Slovenia",
    CountryCode: "SI",
  },
  {
    CountryName: "Svalbard and Jan Mayen",
    CountryCode: "SJ",
  },
  {
    CountryName: "Slovakia",
    CountryCode: "SK",
  },
  {
    CountryName: "Sierra Leone",
    CountryCode: "SL",
  },
  {
    CountryName: "San Marino",
    CountryCode: "SM",
  },
  {
    CountryName: "Senegal",
    CountryCode: "SN",
  },
  {
    CountryName: "Somalia",
    CountryCode: "SO",
  },
  {
    CountryName: "Suriname",
    CountryCode: "SR",
  },
  {
    CountryName: "South Sudan",
    CountryCode: "SS",
  },
  {
    CountryName: "Sao Tome and Principe",
    CountryCode: "ST",
  },
  {
    CountryName: "El Salvador",
    CountryCode: "SV",
  },
  {
    CountryName: "Sint Maarten",
    CountryCode: "SX",
  },
  {
    CountryName: "Syria",
    CountryCode: "SY",
  },
  {
    CountryName: "Swaziland",
    CountryCode: "SZ",
  },
  {
    CountryName: "Turks and Caicos Islands",
    CountryCode: "TC",
  },
  {
    CountryName: "Chad",
    CountryCode: "TD",
  },
  {
    CountryName: "French Southern Territories (the)",
    CountryCode: "TF",
  },
  {
    CountryName: "Togo",
    CountryCode: "TG",
  },
  {
    CountryName: "Thailand",
    CountryCode: "TH",
  },
  {
    CountryName: "Tadjikistan",
    CountryCode: "TJ",
  },
  {
    CountryName: "Tokelau",
    CountryCode: "TK",
  },
  {
    CountryName: "Timor-Leste",
    CountryCode: "TL",
  },
  {
    CountryName: "Turkmenistan",
    CountryCode: "TM",
  },
  {
    CountryName: "Tunisia",
    CountryCode: "TN",
  },
  {
    CountryName: "Tonga",
    CountryCode: "TO",
  },
  {
    CountryName: "East Timor",
    CountryCode: "TP",
  },
  {
    CountryName: "Turkey",
    CountryCode: "TR",
  },
  {
    CountryName: "Trinidad and Tobago",
    CountryCode: "TT",
  },
  {
    CountryName: "Tuvalu",
    CountryCode: "TV",
  },
  {
    CountryName: "Taiwan, Rep of China",
    CountryCode: "TW",
  },
  {
    CountryName: "Tanzania",
    CountryCode: "TZ",
  },
  {
    CountryName: "Ukraine",
    CountryCode: "UA",
  },
  {
    CountryName: "Uganda",
    CountryCode: "UG",
  },
  {
    CountryName: "United States Minor Outlying Islands (the)",
    CountryCode: "UM",
  },
  {
    CountryName: "United States of America",
    CountryCode: "US",
  },
  {
    CountryName: "Uruguay",
    CountryCode: "UY",
  },
  {
    CountryName: "Uzbekistan",
    CountryCode: "UZ",
  },
  {
    CountryName: "Vatican City",
    CountryCode: "VA",
  },
  {
    CountryName: "St Vincent and Grenadines",
    CountryCode: "VC",
  },
  {
    CountryName: "Venezuela",
    CountryCode: "VE",
  },
  {
    CountryName: "British Virgin Islands",
    CountryCode: "VG",
  },
  {
    CountryName: "United States Virgin Islands",
    CountryCode: "VI",
  },
  {
    CountryName: "Viet Nam",
    CountryCode: "VN",
  },
  {
    CountryName: "Vanuatu",
    CountryCode: "VU",
  },
  {
    CountryName: "Wallis and Futuna Islands",
    CountryCode: "WF",
  },
  {
    CountryName: "Samoa",
    CountryCode: "WS",
  },
  {
    CountryName: "Yemen",
    CountryCode: "YE",
  },
  {
    CountryName: "Mayotte",
    CountryCode: "YT",
  },
  {
    CountryName: "Serbia and Montenegro",
    CountryCode: "YU",
  },
  {
    CountryName: "South Africa",
    CountryCode: "ZA",
  },
  {
    CountryName: "Zambia",
    CountryCode: "ZM",
  },
  {
    CountryName: "Zimbabwe",
    CountryCode: "ZW",
  },
];
